import { gql } from "@apollo/client";

export const QUERY_USER_NOTIFICATION_SETTINGS = gql`
  query myNotificationSettings {
    myNotificationSettings {
      id
      category
      isEnable
      deliveryModes
    }
  }
`;

export const UPDATE_USER_NOTIFICATION_SETTINGS = gql`
  mutation updateUserNotificationSetting(
    $id: ID!
    $input: UserNotificationSettingInput!
  ) {
    updateUserNotificationSetting(id: $id, input: $input) {
      id
      category
      isEnable
      deliveryModes
    }
  }
`;
